<template>
    <web-layout :racingstars="$page.props.racingstars" :user="$page.props.user">
        <div class="mx-auto max-w-7xl" id="top">
            <div class="flex flex-col justify-between lg:grid lg:grid-cols-12 lg:gap-4 lg:mt-8 h-screen lg:h-auto">
                <div class="mt-4 md:mt-16 sm:mt-12 lg:mt-0 lg:col-span-8 lg:flex lg:items-center pt-10 sm:pt-0 px-2">
                    <div class="flex flex-col relative">
                        <h1 class="mt-4 text-4xl tracking-tight font-extrabold text-white sm:leading-none lg:text-5xl xl:text-5xl hidden lg:block mx-2">
                            <span class="lg:block ">Free to play!</span>
                            <span class="text-racing-stars-yellow md:block text-4xl block ">Real Racing. Real Prizes.</span>
                        </h1>
                        <h1 class="lg:hidden mt-4 text-4xl tracking-tight font-extrabold text-white sm:leading-none lg:text-5xl xl:text-5xl block mx-2">
                            <span class="text-racing-stars-yellow md:block block text-center mt-5 flex flex-col">
                                <span class="md:block text-white text-[45px] uppercase">Free to play. </span>
                                <span class="md:block text-racing-stars-yellow text-[45px] uppercase">Real Racing.</span>
                                <span class="md:block text-racing-stars-yellow text-[45px] uppercase">Real Prizes.</span>
                            </span>
                        </h1>
                        <span class="hidden font-medium md:flex lg:hidden mt-3 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl mx-2 text-center mx-auto">
                            Choose your horses wisely, accumulate points, and win fantastic prizes.
                        </span>
                        <p class="hidden lg:flex mt-3 text-base text-gray-300 lg:text-lg xl:text-xl mx-2">
                           Outsmart the pros and your friends in this all-day entertainment. Choose your horses wisely, accumulate points, and win fantastic prizes.
                        </p>

                        <!-- <img :src="asset('images/racehorse-right-mobile.png')" class="self-end w-3/4" alt=""/> -->
                        <!-- <img class="absolute top-0 left-0 w-full h-full object-cover z-0 lg:ml-auto lg:w-full" :src="asset('images/racingleague/RL_backdrop.svg')" alt="Purchasing tokens"/> -->
                        <div class="flex relative lg:hidden">
                            <img :src="asset('images/racehorse-right-mobile.png')" class="absolute w-full sm:w-1/2 md:w-3/4 right-0" alt=""/>
                        </div>
                        <!-- desktop ascot banner -->
                        <div class="z-10 px-2 hidden lg:flex flex-col mt-3 shadow-lg">
                            <a href="https://play.google.com/store/apps/details?id=com.racingstars.big_sole">
                                <div class="w-full mx-auto flex flex-col justify-between mb-2">
                                    <img :src="asset('images/simple_app_ad.png')" class="self-center w-full" alt=""/>
                                </div> 
                            </a>
                            <div class="sm:text-center md:mx-auto lg:flex lg:items-center lg:text-left w-full">
                                <div v-if="!$page.props.user?.id" class="mt-3 block w-full sm:rounded-lg">
                                    <Link :href="route('login')" as="button" class="mt-4 font-semibold w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-black bg-racing-stars-yellow hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow">
                                        Login
                                    </Link>
                                    <a href="/register" >
                                        <button class="mt-2 font-semibold w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-black bg-gray-300 hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 mb-3">
                                            Register
                                        </button>
                                    </a>
                                </div>
                                <div v-if="$page.props.user?.id" class="md:mt-6 mt-3 flex flex-col w-full">
                                    <span class="font-bold text-3xl text-white">Welcome back {{ $page.props.user.username }}</span>
                                    <!-- <Link class="text-white mt-1" :href="route('logout')">
                                        (Not you?)
                                    </Link> -->
                                    <button class="mt-4 font-semibold w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-black bg-racing-stars-yellow hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow" onclick="location.href='/dashboard';">
                                        Play Now
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="z-10 mb-3 px-2 lg:hidden">
                    <a href="https://play.google.com/store/apps/details?id=com.racingstars.big_sole">
                        <div class="w-full mx-auto flex flex-col justify-between mb-2">
                            <img :src="asset('images/simple_app_ad_mobile.png')" class="self-center w-[350px] p-1 border border-white/50" alt=""/>
                        </div> 
                    </a>
                    <div class="sm:text-center md:mx-auto w-full">
                        <!-- <div class="hidden pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:flex lg:h-full lg:col-span-6">
                            <img class="rounded-xl  ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none mt-32" :src="asset('images/flipped_laptop.png')" alt="Purchasing tokens" />
                        </div> -->
                        <div v-if="!$page.props.user" class="mt-6 block w-full sm:rounded-lg">
                            <Link :href="route('login')" as="button" class="lg:hidden mt-4 font-semibold w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-black bg-racing-stars-yellow hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow">
                                Login
                            </Link>
                            <a href="/register" >
                                <button class="lg:hidden mt-2 font-semibold w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-black bg-gray-300 hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 mb-3">
                                    Register
                                </button>
                            </a>
                        </div>
                        <div v-if="$page.props.user" class="md:mt-6 mt-3 mx-auto flex flex-col w-full mb-3">
                            <span class="font-semibold text-xl text-center text-white">Welcome back {{ $page.props.user.username }}</span>
                            <!-- <Link class="text-white mt-1" :href="route('logout')">
                                (Not you?)
                            </Link> -->
                            <button class="mt-4 mb-2 font-semibold w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm md:text-lg font-medium text-black bg-racing-stars-yellow hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow" onclick="location.href='/dashboard';">
                                Play Now
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="sm:mt-8 text-white py-4 text-xl text-center font-bold bg-gray-800 block">
<!--            <div class="max-w-7xl flex justify-between mx-auto">-->
<!--                <div>-->
<!--                    <p class="text-base md:text-lg lg:text-xl">Total paid out</p> <br>-->
<!--                    <span class="text-base md:text-lg lg:text-xl text-racing-stars-yellow">{{ formatter.format(totalJackpot) }}</span>-->
<!--                </div>-->
<!--                <div>-->
<!--                    <p class="text-base md:text-lg lg:text-xl">Total winners</p> <br>-->
<!--                    <span class="text-base md:text-lg lg:text-xl text-racing-stars-yellow">{{ totalWinners }}</span>-->
<!--                </div>-->
<!--                <div>-->
<!--                    <p class="text-base md:text-lg lg:text-xl">Next race starts</p> <br>-->
<!--                    <span class="text-base md:text-lg lg:text-xl text-racing-stars-yellow">{{ nextRace }}</span>-->
<!--                </div>-->
<!--            </div>-->
        </div>
        <!-- Jackpots -->
        <!-- <jackpots/> -->

        <!-- Tokens -->
        <tokens/>

        <!-- Horses -->
        <horses/>

        <!-- Bet -->
        <bet/>

        <!-- Change -->
        <change/>

        <!-- Points -->
        <points/>

        <!-- How
        <how/> -->

        <!-- CTA -->
        <cta :next-race-start-time="nextRaceStartTime" />

        <!-- FAQs -->
        <faqs/>

        <!-- CTA -->
        <footer-cta :next-race-start-time="nextRaceStartTime" />
    </web-layout>
</template>
<script>
import { ref, computed } from 'vue'
import GamblingCommissionLogo from '@/Jetstream/GamblingCommissionLogo'
import { Head, Link, usePage } from '@inertiajs/inertia-vue3';
import WebLayout from '@/Layouts/WebLayout.vue'
import RegisterForm from '@/Pages/Auth/Register.vue'
import Jackpots from '@/Pages/Home/Partials/Jackpots.vue'
import Tokens from '@/Pages/Home/Partials/Tokens.vue'
import Horses from '@/Pages/Home/Partials/Horses.vue'
import Bet from '@/Pages/Home/Partials/Bet.vue'
import Change from '@/Pages/Home/Partials/Change.vue'
import Points from '@/Pages/Home/Partials/Points.vue'
// import How from '@/Pages/Home/Partials/How.vue'
import Cta from '@/Pages/Home/Partials/CTA.vue'
import Faqs from '@/Pages/Home/Partials/FAQS.vue'
import FooterCta from '@/Pages/Home/Partials/FooterCTA.vue'
import { useForm } from '@inertiajs/inertia-vue3'
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';
import moment from "moment";
export default {

    props: {
        nextRaceStartTime: String,
        totalWinners: Number,
        totalJackpot: Number,
    },
    components: {
        GamblingCommissionLogo,
        Link,
        WebLayout,
        RegisterForm,
        Jackpots,
        Tokens,
        Horses,
        Bet,
        Change,
        Points,
        // How,
        Cta,
        Faqs,
        FooterCta,
        Carousel,
        Slide,
        Pagination,
        Navigation,
    },

    setup(props) {

        const page = usePage()
        const registerFormVisible = ref(false)

        const form = useForm({
            email: ''
        })
        /**
         * Formatter function required to format currencies/prices correctly.
         *
         * @type {Intl.NumberFormat}
         */
        const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
        })

        const showRegisterForm = () => {
            // form.post(route('pre-registration'), {
            //     onSuccess: () => {
            //         registerFormVisible.value = true
            //     }
            // })

            registerFormVisible.value = true
        }

        const accountCreationEnabled = computed(() => {
            if (page.props.value.user) {
                return false
            }

            return true
        })
        const nextRace = computed(() => {
            return props.nextRaceStartTime ? moment(props.nextRaceStartTime).format('h:mm a') : 'Tomorrow'
        })

        const logout = () => {
            route('logout')
        }


        return {
            formatter,
            nextRace,
            form,
            accountCreationEnabled,
            registerFormVisible,
            showRegisterForm,
            page,
            logout
        }

    }
}

</script>